module.exports =
  '_TERM':
    'TITLE': 'Terms of use'
    'ACCEPT_BUTTON': 'Accept'


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/term/i18n/en.coffee